import { EMAIL_SIGNOL_SUPPORT } from "../../constants/constants";
import { Button, Icon } from "../atoms";

const ErrorPage = ({ buttonText, pageName, icon }) => {
  const signolLogoSrc =
    "https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Neutral.svg";

  const reloadPage = () => {
    window.location.href = "/dashboard";
  };

  return (
    <div
      className={`w-full min-h-screen flex flex-col justify-center items-center gap-10`}
    >
      <div className="m-auto flex flex-col text-center items-center gap-6">
        <Icon
          name={icon ? icon : "brokenChains"}
          backgroundColor="transparent"
          size={36}
          padding={false}
          textColor="neutral-500"
        />
        <img
          className="h-16 w-48"
          src={signolLogoSrc}
          alt="Signol logo"
          color="neutral-500"
        />

        <div>
          <div className="text-lg px-4 text-neutral-500">
            Sorry we couldn't load this page.
          </div>
          <div className="text-lg px-4 ">
            <p className="text-lg px-4 text-neutral-500">
              Try refreshing the page. If the issue persists, contact
            </p>
            <a
              className="text-primary-800 underline font-bold"
              href={`mailto:${EMAIL_SIGNOL_SUPPORT}?subject=Page Loading Issue&body=Error when loading ${pageName ? `the ${pageName}` : "a"} page`}
            >
              {EMAIL_SIGNOL_SUPPORT}
            </a>
          </div>
        </div>
        {!!buttonText && (
          <Button textColor="white" padding={false} onClick={reloadPage}>
            <div className="flex justify-center">
              <div className="my-auto">{buttonText}</div>
            </div>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
